// import React from "react";
// import { useDispatch } from "react-redux";
// import { SwitchIcon } from "../../icons-svg";
// import { removeTab } from "../../features/tabs/tabSlice";

// const TabActionButtons = ({ tabId, children, fallbackFn }) => {
//   const dispatch = useDispatch();

//   const onCloseTab = (e) => {
//     e?.preventDefault?.();
//     e?.stopPropagation?.();

//     // ✅ fallbackFn undefined/null gelirse patlamasın
//     if (typeof fallbackFn === "function") fallbackFn();

//     if (tabId) dispatch(removeTab(tabId));
//   };

//   return (
//     <div
//       className="
//         py-0.5 inline-flex w-full items-center gap-1
//         dark:bg-gray-700 bg-gray-200
//         border-t border-b border-indigo-500 border-opacity-40
//         dark:border-indigo-500 dark:border-opacity-40
//       "
//       role="group"
//     >
//       {/* Tab kapatma butonu */}
//       <button
//         onClick={onCloseTab}
//         type="button"
//         className="
//           py-2 px-2 inline-flex items-center justify-center
//           text-red-500 bg-transparent
//           focus:outline-none focus:ring-0
//           hover:bg-black/5 dark:hover:bg-white/10
//           rounded
//         "
//         title="Close Tab"
//         aria-label="Close Tab"
//       >
//         <SwitchIcon className="h-4 w-4" />
//       </button>

//       {/* ✅ Çocuk aksiyonlar — burada pointer-events garanti + bubbling engeli */}
//       <div
//         className="inline-flex items-center gap-1 pointer-events-auto"
//         onClickCapture={(e) => {
//           // çocuklar tıklanınca buradan yukarıya “tab kapatma” gibi şeyler bulaşmasın
//           // (özellikle parentlarda click handler varsa)
//           e.stopPropagation();
//         }}
//       >
//         {children}
//       </div>
//     </div>
//   );
// };

// TabActionButtons.defaultProps = {
//   fallbackFn: () => false,
// };

// export default TabActionButtons;

import React from "react";
import { useDispatch } from "react-redux";
import { SwitchIcon } from "../../icons-svg";
import { removeTab } from "../../features/tabs/tabSlice";

const TabActionButtons = ({ tabId, children, fallbackFn }) => {
  const dispatch = useDispatch();

  const onCloseTab = (e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();

    try {
      if (typeof fallbackFn === "function") fallbackFn();
    } finally {
      dispatch(removeTab(tabId));
    }
  };

  return (
    <div
      className="py-0.5 inline-flex w-full dark:bg-gray-700 bg-gray-200 border-t border-b border-indigo-500 border-opacity-40 dark:border-indigo-500 dark:border-opacity-40"
      role="group"
    >
      <button
        onClick={onCloseTab}
        type="button"
        className="py-2 px-2 inline-block text-center leading-normal text-red-500 bg-transparent focus:outline-none focus:ring-0"
        title="Close Tab"
      >
        <SwitchIcon className="h-4 w-4" />
      </button>

      {/* ✅ children alanı */}
      <div className="flex items-center gap-2 px-2">{children}</div>
    </div>
  );
};

TabActionButtons.defaultProps = {
  fallbackFn: () => false,
};

export default TabActionButtons;
